import {
  createAction,
  createAsyncThunk,
  createSlice,
  current,
} from "@reduxjs/toolkit";
import { notification } from "antd";
import {
  getAllActivityGroup,
  getAllLayer,
  getAllLayerDetail,
  getAllLimtationCategories,
  getAllOppurtunity,
  getAllOrganization,
  getAllPotential,
  getAllProduct,
  getAllSector,
  getAllSubSector,
  getProvince,
  getSpecifiedQuestions,
} from "./crud";

const initialState = {
  sectors: undefined,
  subSectors: undefined,
  organizations: undefined,
  activityGroups: undefined,
  products: undefined,
  layers: undefined,
  oppurtunities: undefined,
  currentDetail: {},
  oppTitles: undefined,
  potentialsTitles: undefined,
  potentials: undefined,
  layerDetails: [],
  layerDetailsLoaded: true,
  modalStats: false,
  intersectionModalStats: false,
  advanceSearchValue: {},
  province: undefined,
  isSliderOpen: true,
  layersColor: [],
  constInfo: undefined,
  currentPotential: undefined,
  potentialModal: false,
  intersectionResult: undefined,
  intersectionResultModal: false,
  limitationCategories: undefined,
  intersectionInitialState: null,
  intersectionLength: undefined,
  questions: undefined,
  status: "idle",
  intersectionStatus: "idle",
  mapAttr: {
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attr: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  },
  isMapAttrsReady: true,
};

const AccordionsSorter = (data) => {
  const obj = {};
  const arr = [];
  data.map((el) => {
    if (obj[el.LayerCategory.id]) {
      obj[el.LayerCategory.id].children.push(el);
    } else if (!obj[el.LayerCategory.id]) {
      obj[el.LayerCategory.id] = {
        title: el.LayerCategory.title,
        children: [],
      };
      obj[el.LayerCategory.id].children.push(el);
    }
  });
  return obj;
};

export const sectorFetch = createAsyncThunk("home/fetchSectors", async () => {
  const response = await getAllSector();

  return response.data.data;
});

export const setSliderStatus = createAction(
  "home/setSliderStatus",
  (status) => {
    return { payload: status };
  }
);

export const setIntersectionLength = createAction(
  "home/setIntersectionLength",
  (status) => {
    return { payload: status };
  }
);

export const setMapAttr = createAction("home/setMapAttr", (attr) => {
  return { payload: attr };
});

export const setIntersectionStats = createAction(
  "home/setIntersectionStats",
  (status) => {
    return { payload: status };
  }
);

export const setIntersectionResult = createAction(
  "home/setIntersectionResult",
  (status) => {
    return { payload: status };
  }
);

export const setIntersectionResultModal = createAction(
  "home/setIntersectionResultModal",
  (status) => {
    return { payload: status };
  }
);

export const setPotentialModal = createAction(
  "home/setPotentialModal",
  (status) => {
    return { payload: status };
  }
);

export const setConstInfo = createAction("home/setConstInfo", (status) => {
  return { payload: status };
});

export const subSectorFetch = createAsyncThunk(
  "home/fetchSubSectors",
  async (params) => {
    const response = await getAllSubSector(params);

    return response.data.data;
  }
);

export const questionFetch = createAsyncThunk(
  "home/fetchQuestions",
  async (params) => {
    const response = await getSpecifiedQuestions(params);

    return response.data.data;
  }
);

export const potentialFetch = createAsyncThunk(
  "home/fetchPotentials",
  async (params) => {
    const response = await getAllPotential(params);

    return response.data.data;
  }
);

export const organizationFetch = createAsyncThunk(
  "home/fetchOrganizations",
  async () => {
    const response = await getAllOrganization();

    return response.data.data;
  }
);

export const activityGroupFetch = createAsyncThunk(
  "home/fetchActivityGroupFetch",
  async (params) => {
    const response = await getAllActivityGroup(params);

    return response.data.data;
  }
);

export const productFetch = createAsyncThunk(
  "home/productFetch",
  async (params) => {
    const response = await getAllProduct(params);

    return response.data.data;
  }
);

export const setModalStats = createAction("home/setModalStats", (action) => {
  return { payload: action };
});

export const setIntersectionModalStats = createAction(
  "home/setIntersectionModalStats",
  (action) => {
    return { payload: action };
  }
);

export const setCurrentPotential = createAction(
  "home/setCurrentPotential",
  (action) => {
    return { payload: action };
  }
);

export const setLayerColor = createAction("home/setLayerColor", (action) => {
  return { payload: action };
});

export const setCurrentDetails = createAction(
  "home/setCurrentDetail",
  (action) => {
    return { payload: action };
  }
);

export const setAdvanceSearchValue = createAction((action) => {
  const data = { ...initialState.advanceSearchValue, ...action };
  return { payload: data };
});

export const advanceSearchValuesClear = createAction(
  "home/advanceSearchValuesClear",
  (action) => {
    return { payload: action };
  }
);

export const setSectors = createAction("home/setSectors", (action) => {
  return { payload: action };
});

export const setQuestions = createAction("home/setQuestions", (action) => {
  return { payload: action };
});

export const setSubSectors = createAction("home/setSubSectors", (action) => {
  return { payload: action };
});

export const setActivityGroups = createAction(
  "home/setActivityGroups",
  (action) => {
    return { payload: action };
  }
);

export const setLayerDetailsLoaded = createAction(
  "home/setLayerDEtailsLoaded",
  (action) => {
    return { payload: action };
  }
);

export const setProducts = createAction("home/setProducts", (action) => {
  return { payload: action };
});

export const subSectorClear = createAction("home/subSectorsClear", (action) => {
  return { payload: action };
});

export const agClear = createAction("home/agClear", (action) => {
  return { payload: action };
});

export const setIntersectionInitialState = createAction(
  "home/setIntersectionState",
  (action) => {
    return { payload: action };
  }
);

export const productClear = createAction("home/productClear", (action) => {
  return { payload: action };
});

export const layerDetailDeleteHandler = createAction(
  "home/layerDetailDeleteHandler",
  (action) => {
    return { payload: action };
  }
);

export const setIsMapAttrsReady = createAction(
  "home/setIsMapAttrsReady",
  (action) => {
    return { payload: action };
  }
);

export const layerFetch = createAsyncThunk("home/layerFetch", async (token) => {
  const response = await getAllLayer(token);

  return AccordionsSorter(response.data.data);
});

export const limitationCategoryFetch = createAsyncThunk(
  "home/limitationCategoryFetch",
  async (token) => {
    const response = await getAllLimtationCategories();

    return response.data.data;
  }
);

export const provinceFetch = createAsyncThunk(
  "home/provinceFetch",
  async (id) => {
    const response = await getProvince(id);

    return response.data.data;
  }
);

export const layerDetailFetch = createAsyncThunk(
  "home/layerDetailFetch",
  async (params) => {
    let layerColor = params.color;
    let layerMarker = params.marker;

    // delete params.color;
    delete params.marker;

    const response = await getAllLayerDetail(params);
    // response.data.data[0].jsonb_build_object.features.map((ne) => {
    //   ne.color = layerColor;
    // });

    if (layerColor) {
      response.data.data[0].jsonb_build_object.color = layerColor;
    }

    if (layerMarker) {
      response.data.data[0].jsonb_build_object.marker = layerMarker;
    }

    return response.data.data[0].jsonb_build_object;
  }
);

export const oppFetch = createAsyncThunk("home/oppFetch", async (params) => {
  const response = await getAllOppurtunity(params);
  return response.data.data;
});

export const setLayerDetails = createAction(
  "home/setLayerDetails",
  (payload) => {
    return { payload };
  }
);

export const home = createSlice({
  name: "main",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(sectorFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(sectorFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.sectors = action.payload;
      });

    builder
      .addCase(subSectorFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(subSectorFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.subSectors = action.payload;
      });

    builder
      .addCase(questionFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(questionFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.questions = action.payload;
      });

    builder
      .addCase(potentialFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(potentialFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.potentials = action.payload;
        state.potentialsTitles = action.payload.map((el) => {
          return { id: el.id, title: el.title };
        });
      });

    builder
      .addCase(organizationFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(organizationFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.organizations = action.payload;
      });

    builder
      .addCase(activityGroupFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(activityGroupFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.activityGroups = action.payload;
      });

    builder
      .addCase(productFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(productFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.products = action.payload;
      });

    builder
      .addCase(oppFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(oppFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.oppurtunities = action.payload;
        state.oppTitles = action.payload.map((el) => {
          return { id: el.id, title: el.title };
        });
      });

    builder.addCase(setModalStats, (state, action) => {
      state.modalStats = action.payload;
    });

    builder.addCase(setLayerDetails, (state, action) => {
      return { ...state, layerDetails: action.payload };
    });

    builder.addCase(setIntersectionModalStats, (state, action) => {
      state.intersectionModalStats = action.payload;
    });

    builder.addCase(setMapAttr, (state, action) => {
      state.mapAttr = action.payload;
    });

    builder.addCase(setCurrentPotential, (state, action) => {
      state.currentPotential = action.payload;
    });

    builder.addCase(setIntersectionLength, (state, action) => {
      state.intersectionLength = action.payload;
    });

    builder.addCase(setLayerColor, (state, action) => {
      state.layersColor = action.payload;
    });

    builder.addCase(setCurrentDetails, (state, action) => {
      state.currentDetail = action.payload;
    });

    builder.addCase(setQuestions, (state, action) => {
      state.questions = action.payload;
    });

    builder.addCase(setAdvanceSearchValue, (state, action) => {
      state.advanceSearchValue = action.payload;
    });

    builder.addCase(setIntersectionResultModal, (state, action) => {
      state.intersectionResultModal = action.payload;
    });

    builder.addCase(setIntersectionStats, (state, action) => {
      state.intersectionStatus = action.payload;
    });

    builder.addCase(setIntersectionInitialState, (state, action) => {
      state.intersectionInitialState = action.payload;
    });

    builder.addCase(advanceSearchValuesClear, (state, action) => {
      state.advanceSearchValue = action.payload;
    });

    builder.addCase(subSectorClear, (state, action) => {
      state.subSectors = action.payload;
    });

    builder.addCase(agClear, (state, action) => {
      state.activityGroups = action.payload;
    });

    builder.addCase(productClear, (state, action) => {
      state.products = action.payload;
    });

    builder.addCase(setSectors, (state, action) => {
      return { ...state, subSectors: action.payload };
    });

    builder.addCase(setSubSectors, (state, action) => {
      state.subSectors = null;
    });

    builder.addCase(setActivityGroups, (state, action) => {
      state.activityGroups = action.payload;
    });

    builder.addCase(setProducts, (state, action) => {
      state.products = action.payload;
    });

    builder.addCase(setSliderStatus, (state, action) => {
      state.isSliderOpen = action.payload;
    });

    builder.addCase(setPotentialModal, (state, action) => {
      state.potentialModal = action.payload;
    });

    builder.addCase(setIsMapAttrsReady, (state, action) => {
      state.isMapAttrsReady = action.payload;
    });

    builder.addCase(setConstInfo, (state, action) => {
      state.constInfo = action.payload;
    });

    builder.addCase(setIntersectionResult, (state, action) => {
      state.intersectionResult = action.payload;
    });

    builder.addCase(layerDetailDeleteHandler, (state, action) => {
      const statez = current(state);

      state.layerDetails = statez.layerDetails.filter((el) => {
        return el.layerId !== action.payload.layerId;
      });
    });

    builder
      .addCase(limitationCategoryFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(limitationCategoryFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.limitationCategories = action.payload;
      });

    builder
      .addCase(layerFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(layerFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.layers = action.payload;
      });
    builder.addCase(setLayerDetailsLoaded, (state, action) => {
      return { ...state, layerDetailsLoaded: action.payload };
    });

    builder
      .addCase(layerDetailFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(layerDetailFetch.fulfilled, (state, action) => {
        // state.status = "idle";
        return {
          ...state,
          layerDetails: [...state.layerDetails, action.payload],
        };
      });

    builder
      .addCase(provinceFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(provinceFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.province = action.payload;
      })
      .addCase(provinceFetch.rejected, () => {
        notification.error({
          message: `مشکلی در دریافت اطلاعات بوجود آمد`,
          description:
            "مشکلی در دریافت اطلاعات بوجود آمد, در صورت دسترسی به اینترنت صفحه را ریفرش کنید",
          placement: "bottom",
        });
      });
  },
});

export const selectLicenseList = (state) => state.main;

export default home.reducer;
